import { createFileRoute } from '@tanstack/react-router';
import { CircleCheck } from 'lucide-react';
import z from 'zod';

import { useTranslation } from '@hooks/useTranslation.hook';

import { SurveyStatusContent } from '../@components/StatusContent';

const REVIEW_LINK_URL = import.meta.env.VITE_REVIEW_LINK_URL ?? '';

const submittedSearchSchema = z.object({
  overallSatisfaction: z.coerce.number<number>().int().min(1).max(4).optional(),
});

export const Route = createFileRoute(
  '/_layout/$lang/quality-survey/_layout/submitted',
)({
  component: Submitted,
  validateSearch: search => submittedSearchSchema.parse(search),
});

function Submitted() {
  const { overallSatisfaction } = Route.useSearch();

  if (overallSatisfaction && overallSatisfaction <= 2) {
    return (
      <SurveyStatusContent
        icon={CircleCheck}
        iconBgClassName="bg-emerald-50"
        iconClassName="text-emerald-500"
        messageKey="survey.submitted.negative.message"
        titleKey="survey.submitted.title"
      />
    );
  }

  return <PositiveSubmitted />;
}

function PositiveSubmitted() {
  const { t } = useTranslation();

  return (
    <SurveyStatusContent
      icon={CircleCheck}
      iconBgClassName="bg-emerald-50"
      iconClassName="text-emerald-500"
      messageKey="survey.submitted.positive.message"
      titleKey="survey.submitted.title"
    >
      <a
        className="inline-flex w-full items-center justify-center rounded-lg bg-emerald-500 px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-emerald-600"
        href={REVIEW_LINK_URL}
        rel="noopener noreferrer"
        target="_blank"
      >
        {t('survey.submitted.review_link')}
      </a>
    </SurveyStatusContent>
  );
}
